import { PresentationTemplateEditorBundle } from './PresentationTemplateEditor.types';

/**
 * Fields that live on the bundle itself rather than on one of its
 * configurations, and that most editors therefore don't own.
 *
 * Every config modal and the slide editor rebuild a bundle from scratch out of
 * their own form values, so anything not explicitly carried across is dropped
 * the next time the user edits that bundle. Spread the result FIRST in a
 * rebuilt bundle so a builder that genuinely does own one of these fields (the
 * waterfall overview and comparison modals edit `templateNotes`) can still
 * override it:
 *
 *     return {
 *       ...getCarriedOverBundleFields(existingBundle),
 *       id: ...,
 *       templateNotes, // this builder owns the field, so it wins
 *     };
 *
 * When a new bundle-level field is added, add it here rather than to each
 * rebuild site.
 */
export function getCarriedOverBundleFields(
  existingBundle: PresentationTemplateEditorBundle | undefined
): Pick<
  PresentationTemplateEditorBundle,
  'templateNotes' | 'excludeFromOutput' | 'additionalPromptContext'
> {
  return {
    templateNotes: existingBundle?.templateNotes,
    excludeFromOutput: existingBundle?.excludeFromOutput,
    additionalPromptContext: existingBundle?.additionalPromptContext,
  };
}
